const register = {
  loginCredentials: "Inloggegevens", // translated
  companyInformation: "bedrijfsinformatie", // translated
  contactDetails: "Contact details", // translated
  businessName: "Bedrijfsnaam", // translated
  businessAddress: "Bedrijfsadres", // translated
  registrationCode: "Registratiecode", // translated
  businessRegistrationNumber: "Bedrijfsregistratienummer", // translated
  websiteUrl: "Website URL", // translated
  mobilePhone: "Mobiele telefoon", // translated
  regionStateProvince: "Regio/Staat/Provincie", // translated
  legalTitle: "Legale titel", // translated
  city: "Stad", // translated
  postalCode: "Postcode", // translated
  registrationSuccess: "Registratie succes.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Wacht even en u wordt doorgestuurd naar de startpagina.", // translated
  usernameEmail: "Gebruikersnaam (e-mail)", // translated
  password: "Wachtwoord", // translated
  verifyPassword: "Wachtwoord verifiëren", // translated
  documents: "Documenten", // translated
  termsAndConditionsSection: "Algemene voorwaarden", // translated
  certificateOfIncorporation: "Oprichtingsakte", // translated
  acceptTermsAndConditions: "Algemene voorwaarden accepteren", // translated
  country: "Land", // translated
  brandName: "Merknaam", // translated
  register: "Registreren", // translated
  isRequired: "Is verplicht", // translated
  passwordMin8Chars: "Moet minimaal 8 tekens bevatten", // translated
  passwordRequiresDigit: "Moet minimaal 1 cijfer bevatten", // translated
  passwordRequiresLowercase: "Moet minimaal 1 kleine letter bevatten", // translated
  passwordRequiresUppercase: "Moet minimaal 1 hoofdletter bevatten", // translated
  passwordRequiresSpecialChar: 'Moet minimaal 1 speciaal teken bevatten (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Bestand uploaden", // translated
  filename: "Bestandsnaam:", // translated
  fileType: "Type:", // translated
  fileSize: "Grootte:", // translated
  maxFileSize10Mb: "Max.: 10 MB", // translated
  supportedFileTypes: "Ondersteunde bestandstypen:", // translated
  showPassword: "Wachtwoord tonen", // translated
  hidePassword: "Wachtwoord verbergen", // translated
  notAvailable: "N.v.t.", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "bijv. +31612345678", // translated
  websiteUrlPlaceholder: "http://www.voorbeeld.nl", // translated
  loading: "Laden...", // translated
  uploadingDocument: "Document uploaden...", // translated
  percentUploaded: "{{percent}}% geüpload", // translated
  registrationSuccessful: "Registratie geslaagd.", // translated
  failedToUploadDocument: "Document uploaden mislukt.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} moet langer zijn dan {{min}} tekens", // translated
  fieldMustBeValidEmail: "{{field}} moet een geldig e-mailadres zijn", // translated
  fieldPasswordMinLength: "{{field}} moet minimaal 8 tekens bevatten", // translated
  fieldPasswordRequiresDigit: "{{field}} moet minimaal 1 cijfer bevatten", // translated
  fieldPasswordRequiresLowercase: "{{field}} moet minimaal 1 kleine letter bevatten", // translated
  fieldPasswordRequiresUppercase: "{{field}} moet minimaal 1 hoofdletter bevatten", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} moet minimaal 1 speciaal teken bevatten (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} komt niet overeen met {{otherField}}", // translated
  fieldBetweenLength: "{{field}} moet tussen {{min}} en {{max}} tekens zijn", // translated
  postalCodeBetweenLength: "{{field}} moet tussen {{min}} en {{max}} tekens zijn", // translated
  invalidUrlFormat: "Ongeldig URL-formaat", // translated
  invalidEmailFormat: "Ongeldig e-mailformaat", // translated
  emailMustMatchUsername: "e-mail moet hetzelfde zijn als gebruikersnaam (e-mail)", // translated
  mobilePhoneIsRequired: "Mobiele telefoon is verplicht", // translated
  certificateFileTooLarge: "Oprichtingsakte is te groot", // translated
  termsMustBeAccepted: "Algemene voorwaarden moeten worden geaccepteerd", // translated
};


export default register;
